import { cn } from '@/lib/helpers/utils';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';
import { ATFImage } from './utils/Image';
interface Props {
  /** Gatsby image - required */
  image?: IGatsbyImageData;
  /** Image alt - required */
  imageAlt?: string;
  /** A media object (i.e. video), will override any image that is passed in */
  media?: any;
  /** Background colour for the content side of the section */
  bkgColor: string;
  /** Switch around the cols ltr or rtl */
  reverse?: boolean;
  /** Override the default image classes */
  imgClass?: string;
  /** Override the default media column classes */
  mediaColClass?: string;
  /** Override the default content classes */
  contentClass?: string;
  /** Override the default content column classes */
  contentColClass?: string;
  /** Show shadow */
  shadow?: boolean;
  /** Show stroke */
  stroke?: boolean;
  /** Show rounded corners */
  rounded?: boolean;
  /** Content to be rendered in content column */
  children?: React.ReactChild | React.ReactChild[];
  /** Image will be above the fold */
  atf?: boolean;
}

/**
 * MediaTwoCol
 * @return {JSX}
 */
export default function MediaTwoCol({
  image,
  imageAlt,
  media,
  bkgColor,
  reverse,
  imgClass = 'aspect-[3/2]',
  mediaColClass = 'lg:w-6/12',
  contentClass = 'px-6 py-10 lg:p-12',
  contentColClass = 'lg:w-6/12',
  shadow,
  stroke,
  rounded,
  children,
  atf = false
}: Props) {
  return (
    <div className="h-full w-full">
      <div
        className={cn(
          'h-full mx-auto max-w-[450px] lg:max-w-none flex flex-col lg:flex-row lg:min-h-120',
          bkgColor ? bkgColor : '',
          shadow ? 'shadow-xl' : '',
          stroke ? 'border border-gray-200' : '',
          rounded ? 'rounded-2xl' : ''
        )}
      >
        <div
          className={cn(
            media ? '' : 'lg:overflow-hidden',
            reverse ? 'order-2' : 'order-1',
            mediaColClass ? mediaColClass : ''
          )}
        >
          {media ? (
            media
          ) : image ? (
            atf ? (
              <ATFImage
                alt={imageAlt ?? ''}
                imageData={image}
                eager={true}
                imageClass={cn(
                  'w-full lg:h-full will-change-transform object-cover',
                  imgClass ? imgClass : '',
                  rounded
                    ? reverse
                      ? 'rounded-b-2xl lg:rounded-l-none lg:rounded-r-2xl'
                      : 'rounded-t-2xl lg:rounded-r-none lg:rounded-l-2xl'
                    : ''
                )}
              />
            ) : (
              <GatsbyImage
                className={cn(
                  'w-full lg:h-full will-change-transform',
                  imgClass ? imgClass : '',
                  rounded
                    ? reverse
                      ? 'rounded-b-2xl lg:rounded-l-none lg:rounded-r-2xl'
                      : 'rounded-t-2xl lg:rounded-r-none lg:rounded-l-2xl'
                    : ''
                )}
                image={image}
                alt={imageAlt ?? ''}
              />
            )
          ) : (
            ''
          )}
        </div>
        <div
          className={cn(
            'w-full h-full',
            'flex self-center',
            reverse ? 'order-1' : 'order-2',
            contentClass ? contentClass : '',
            contentColClass ? contentColClass : ''
          )}
        >
          <div className="w-full">{children}</div>
        </div>
      </div>
    </div>
  );
}
